module.exports = __webpack_public_path__ + "static/media/small-works-great-wonders.e3bc3ecf.png";